<template>
  <page-content title="Meja 5: Konsultasi">
    <br />
    <c-input-date id="check-date" label="Tanggal Periksa">
      <datetime
        type="date"
        format="dd/LL/yyyy"
        value-zone="local"
        v-model="formBehavioralFactor.date"
      />
    </c-input-date>

    <div class="input-self-error">
      <v-select
        placeholder="Pasien yang diperiksa"
        label="fullname"
        :options="patients"
        :class="{ 'input-error': validations.patient.error }"
        v-model="patient"
      >
        <div slot="no-options">Tidak ada pasien tersedia.</div>
      </v-select>
      <p class="self-error-message" v-if="validations.patient.error">
        {{ validations.patient.message }}
      </p>
    </div>
    <br />

    <bulma-accordion>
      <bulma-accordion-item>
        <h4 slot="title">Riwayat PTM</h4>
        <div slot="content">
          <h4>Riwayat PTM pada Keluarga</h4>
          <table class="table-history-list">
            <tr>
              <td>Penyakit Diabetes</td>
              <td>{{ familyHistory.diabetes == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Hipertensi</td>
              <td>{{ familyHistory.hypertention == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Jantung</td>
              <td>{{ familyHistory.cardiac == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Stoke</td>
              <td>{{ familyHistory.stroke == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Asma</td>
              <td>{{ familyHistory.asthma == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Kanker</td>
              <td>{{ familyHistory.cancer == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Kolesterol Tinggi</td>
              <td>{{ familyHistory.cholesterol == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
          </table>
          <br />
          <h4>Riwayat PTM pada Diri Sendiri</h4>
          <table class="table-history-list">
            <tr>
              <td>Penyakit Diabetes</td>
              <td>{{ selfHistory.diabetes == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Hipertensi</td>
              <td>{{ selfHistory.hypertention == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Jantung</td>
              <td>{{ selfHistory.cardiac == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Stoke</td>
              <td>{{ selfHistory.stroke == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Asma</td>
              <td>{{ selfHistory.asthma == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Penyakit Kanker</td>
              <td>{{ selfHistory.cancer == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
            <tr>
              <td>Kolesterol Tinggi</td>
              <td>{{ selfHistory.cholesterol == "1" ? "Ya" : "Tidak" }}</td>
            </tr>
          </table>
        </div>
      </bulma-accordion-item>
      <bulma-accordion-item>
        <h4 slot="title">Faktor Risiko Perilaku</h4>
        <div slot="content">
          <table class="table-history-list">
            <tr>
              <td>Merokok</td>
              <td>
                {{ formBehavioralFactor.smoking == "1" ? "Ya" : "Tidak" }}
              </td>
            </tr>
            <tr>
              <td>Makan Sayur dan Buah &lt; 5 porsi sehari</td>
              <td>
                {{
                  formBehavioralFactor.lackVegetableAndFruit == "1"
                    ? "Ya"
                    : "Tidak"
                }}
              </td>
            </tr>
            <tr>
              <td>Penyakit Jantung</td>
              <td>
                {{
                  formBehavioralFactor.lackOfPhysicalActivity == "1"
                    ? "Ya"
                    : "Tidak"
                }}
              </td>
            </tr>
            <tr>
              <td>Penyakit Stoke</td>
              <td>
                {{ formBehavioralFactor.alcohol == "1" ? "Ya" : "Tidak" }}
              </td>
            </tr>
          </table>
        </div>
      </bulma-accordion-item>
      <bulma-accordion-item>
        <h4 slot="title">Pengukuran</h4>
        <div slot="content">
          <table class="table-history-list val-right">
            <tr>
              <td>Berat Badan</td>
              <td>{{ formBehavioralFactor.weight }}kg</td>
            </tr>
            <tr>
              <td>Tinggi Badan</td>
              <td>{{ formBehavioralFactor.height }}cm</td>
            </tr>
            <tr>
              <td>Lingkar Perut</td>
              <td>{{ formBehavioralFactor.waist }}cm</td>
            </tr>
            <tr>
              <td>Tekanan Darah</td>
              <td>
                {{
                  formBehavioralFactor.systolicPressure +
                  "/" +
                  formBehavioralFactor.diastolicPressure
                }}
              </td>
            </tr>
            <tr>
              <td>Kolesterol</td>
              <td>{{ formBehavioralFactor.cholesterol }}</td>
            </tr>
            <tr>
              <td>Gula Darah</td>
              <td>{{ formBehavioralFactor.bloodSugar }}</td>
            </tr>
            <tr>
              <td>Asam Urat</td>
              <td>{{ formBehavioralFactor.uricAcid }}</td>
            </tr>
          </table>
        </div>
      </bulma-accordion-item>
    </bulma-accordion>
    <br />

    <c-input
      id="problem"
      label="Masalah yang Ditemukan"
      type="textarea"
      v-model="formBehavioralFactor.problem"
      :error="validations.problem.error"
      :error-message="validations.problem.message"
    />

    <c-input
      id="suggestion"
      label="Saran dan Tindak Lanjut"
      type="textarea"
      v-model="formBehavioralFactor.suggestion"
      :error="validations.suggestion.error"
      :error-message="validations.suggestion.message"
    />

    <c-input-date
      id="referral-date"
      label="Tanggal Dirujuk"
      :error="validations.referralDate.error"
      :error-message="validations.referralDate.message"
    >
      <datetime
        type="date"
        format="dd/LL/yyyy"
        value-zone="local"
        v-model="formBehavioralFactor.referralDate"
      />
    </c-input-date>

    <c-input
      id="referral-reason"
      label="Alasan Rujukan"
      type="textarea"
      v-model="formBehavioralFactor.referralReason"
      :error="validations.referralReason.error"
      :error-message="validations.referralReason.message"
    />

    <button
      class="btn btn-block btn-primary"
      @click="doSubmit"
      v-if="!isLoading"
    >
      Simpan
    </button>
    <p align="center" v-else>
      <pulse-loader :loading="isLoading" size="10px" :color="colorPrimary" />
    </p>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "measurement",
  data: function () {
    return {
      validations: {
        patient: {
          error: false,
          message: "Something went wrong.",
        },
        problem: {
          error: false,
          message: "Something went wrong.",
        },
        suggestion: {
          error: false,
          message: "Something went wrong.",
        },
        referralDate: {
          error: false,
          message: "Something went wrong.",
        },
        referralReason: {
          error: false,
          message: "Something went wrong.",
        },
      },
      patient: "",
      isLoading: false,
    };
  },
  watch: {
    patient: function () {
      this.updateCheckup();
    },
    "formBehavioralFactor.date": function () {
      this.getQueuedPatients();
    },
  },
  computed: {
    ...mapGetters({
      patients: "queuedPatients",
      formBehavioralFactor: "checkup",
      selfHistory: "selfHistory",
      familyHistory: "familyHistory",
    }),
  },
  methods: {
    isFormValid: function () {
      // Reset the errors
      this.validations.patient.error = false;
      this.validations.problem.error = false;
      this.validations.suggestion.error = false;
      this.validations.referralDate.error = false;
      this.validations.referralReason.error = false;

      if (this.isEmpty(this.patient)) {
        this.validations.patient.error = true;
        this.validations.patient.message = "Pasien harus diisi.";
      }
      if (this.isEmpty(this.formBehavioralFactor.problem)) {
        this.validations.problem.error = true;
        this.validations.problem.message = "Masalah harus diisi.";
      }
      if (this.isEmpty(this.formBehavioralFactor.suggestion)) {
        this.validations.suggestion.error = true;
        this.validations.suggestion.message =
          "Saran dan Tindak Lanjut harus diisi.";
      }

      for (const key in this.validations) {
        const field = this.validations[key];
        if (field["error"]) return false;
      }
      return true;
    },
    doSubmit: function () {
      if (this.isFormValid()) {
        this.isLoading = true;
        const userId = this.patient.id;
        const payload = this.formBehavioralFactor;
        this.$store
          .dispatch("createOrUpdateCheckup", { userId, payload })
          .then(() => {
            // Reset form
            this.form = this.originalForm;
            this.isLoading = false;
            this.$toasted.success("Berhasil disimpan.");
          })
          .catch(() => {
            this.isLoading = false;
            this.$toasted.error("Gagal! Terjadi kesalahan.");
          });
      }
    },
    updateCheckup: function () {
      this.$store.dispatch("resetCheckup");
      this.$store.dispatch("resetDiseasesHistory");
      if (
        !this.isEmpty(this.patient) &&
        !this.isEmpty(this.formBehavioralFactor.date)
      ) {
        const userId = this.patient.id;
        const date = LuxonDateTime.fromISO(
          this.formBehavioralFactor.date
        ).toFormat("yyyy-LL-dd");
        this.$store.dispatch("getCheckup", { userId, date });
        this.$store.dispatch("getDiseasesHistory", userId);
      }
    },
    getQueuedPatients: function () {
      const date = LuxonDateTime.fromISO(
        this.formBehavioralFactor.date
      ).toFormat("yyyy-LL-dd");
      this.$store.dispatch("startPageLoading");
      this.$store
        .dispatch("getQueuedPatients", date)
        .then(() => {
          this.$store.dispatch("stopPageLoading");
        })
        .catch(() => {
          this.$store.dispatch("stopPageLoading");
        });
    },
  },
  created: function () {
    this.$store.dispatch("resetCheckup");
    this.$store.dispatch("resetDiseasesHistory");
    this.getQueuedPatients();
  },
};
</script>
